/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";
import App from "@/containers/App/App";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

import * as serviceWorker from "./serviceWorker";
import { ChainProvider } from "./containers/context/context";
ReactDOM.render(
  <React.StrictMode>
    <ChainProvider>
      <App />
    </ChainProvider>
    <ToastContainer />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
